import React, { Component } from "react";
import { css } from "react-emotion";
import styled from "react-emotion";
import { SmallModal } from "appStyles";
import { validateUrl } from "helpers";

const container = css`
  position: relative;
  max-height: 50%;
  width: 100%;
  color: black;
  padding: 10px;
  /* border: 1px solid red; */
`;

const LinksStyle = styled("div")`
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: auto;
  grid-auto-rows: 1fr;
  grid-auto-flow: row;
`;

const linkStyle = css`
  position: relative;
  display: flex;
  flex-direction: row;
  margin-top: 15px;
  flex: 1 1 30%;
  justify-content: center;
`;

const iconStyle = css`
  height: 50px;
  width: 50px;
`;

const uploadIconStyle = css`
  font-size: 12px;
  cursor: pointer;
`;

const linkModel = css`
  position: absolute;
  z-index: 10;
  width: 225px;
  height: 100px;
  left: 60px;
  top: 30px;
  background: white;
  border-radius: 5px;
  padding: 10px;
  border: 1px solid aqua;
  display: flex;
  flex-direction: row;
`;

const linkModelTop = css`
  display: flex;
  flex-direction: row;
`;

const linkModelBottom = css`
  margin: 10px;

  input {
    width: 100%;
    border: none;
    border-bottom: 1px solid grey;
    background: none;
    outline: none;
    margin: 0 0 10 0;
    box-shadow: none;
    font-family: "Quicksand", "M PLUS Rounded 1c";

    &:hover,
    :focus {
      opacity: 1;
      transition: opacity 0.4s;
    }

    &::placeholder {
      color: rgba(200, 200, 200, 1);
    }
  }
`;

class Links extends Component {
  state = {
    showLinkIdx: null,
  };

  showModel = (linkIdx) => {
    this.setState({ showLinkIdx: linkIdx });
  };

  closeModel = () => {
    this.setState({ showLinkIdx: null });
  };

  uploadWidget = (linkIdx) => {
    let { updateLinkIcon } = this.props;
    cloudinary.openUploadWidget(
      {
        cloud_name: "jerryzlau",
        upload_preset: "appify",
        tags: ["xmas"],
      },
      function (error, result) {
        if (error) {
          return console.error(error);
        }

        let {
          info: { url, original_filename, original_extension },
        } = result;

        let image = {
          url,
          fileName: `${original_filename}.${original_extension}`,
          backgroundColor: null,
          description: original_filename,
          clickAction: null,
        };

        if (result.event === "success") {
          updateLinkIcon(image, linkIdx);
        }
      }
    );
  };

  render() {
    const { links, editMode, removeLink, clearLink, updateLink } = this.props;

    const { showLinkIdx } = this.state;

    if (!links) return null;

    return (
      <div className={container}>
        <LinksStyle editMode={editMode}>
          {links &&
            links.map((link, idx) => {
              const { url, icon, displayName } = link;

              if (!editMode && url === "") return null;

              return (
                <div
                  className={linkStyle}
                  key={idx}
                  onMouseEnter={() => this.showModel(idx)}
                >
                  {editMode && (
                    <SmallModal
                      hidden={showLinkIdx !== idx}
                      left="0em"
                      top="0em"
                    >
                      {/* onMouseLeave={() => this.closeModel(idx)}> */}
                      <div className={linkModelTop}>
                        <img className={iconStyle} src={icon} />
                      </div>
                      <div className={linkModelBottom}>
                        <input
                          value={displayName}
                          placeholder="Display name"
                          onChange={updateLink("displayName", idx)}
                        />
                        <input
                          value={url}
                          placeholder="https://"
                          onChange={updateLink("url", idx)}
                        />
                      </div>
                      <div
                        className={uploadIconStyle}
                        onClick={() => this.closeModel(idx)}
                      >
                        X
                      </div>
                    </SmallModal>
                  )}
                  <a href={validateUrl(url)} target="_blank">
                    <img className={iconStyle} src={icon} />
                  </a>
                  {/* don't need this feature until V2 */}
                  {/* {editMode && <div className={uploadIconStyle} 
                  onClick={() => this.uploadWidget(idx)}>✏️</div>}                 */}
                </div>
              );
            })}
        </LinksStyle>
      </div>
    );
  }
}

export default Links;
